import React from 'react'
import {
  BUTTON_SIZE,
  BUTTON_TYPE,
  HEADING_TYPE,
  TEXT_SIZES,
} from '@helpers/constants'
import Heading from '@components/Heading'
import Text from '@components/Text'
import Button from '@components/Button'
import { Link } from 'react-router-dom'

const FourOhOne = () => {
  return (
    <div className={'h-[100vh] -mt-20 flex items-center'}>
      <div className={'bg-lightMediumGrey rounded-sm max-w-[600px] mx-auto py-16 px-32 flex flex-col justify-center gap-4 text-center'}>
        <Heading headingLevel={HEADING_TYPE.H1} size={TEXT_SIZES.XXLARGE}>
          Du har inte tillgång till det här innehållet
        </Heading>

        <Text>Det du försöker titta på ingår inte i din licens. Om du har fått den här länken från din lärare, prata med hen om att det inte fungerade.</Text>

        <div>
          <Button
            type={BUTTON_TYPE.PRIMARY}
            size={BUTTON_SIZE.LARGE}
          >
            <Link to="/bokhylla" replace={true}>
              Gå till min bokhylla
            </Link>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default FourOhOne
